export enum SubnavigationCtaButtonsDisplayMethod {
  Manual = 'manual',
  Automate = 'automate',
}

export enum ScenarioKeys {
  Default = 'default',
  Alternative = 'alternative',
}

export enum SubnavigationCtaIcons {
  Configurator = 'bds/car-config/24',
  Shop = 'bds/shopping-cart/24',
  Enquiry = 'bds/pencil-document/24',
}

//export types from VCA service and import
export enum SubnavigationCtaTypes {
  Configurator = 'CONFIGURATOR',
  Shop = 'ONLINE_SHOP',
  Enquiry = 'ENQUIRY',
}
